import { addDays, addWeeks, differenceInDays, format, getDay, getWeek, startOfWeek, subDays } from "date-fns";
import React, { useEffect, useState } from "react";
import { checkEmailInValid, getFirebaseDocs, stripeKey } from "../common";
import { addDoc, collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../firebase-config";
import ModalComp from "../components/Modal";
import { useDispatch, useSelector } from "react-redux";
import { setBookings } from "../redux/userReducer";
import Cart from '../assets/Cart.png'
import axios from 'axios'
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import { toast } from "react-toastify";

import UniformImg from '../assets/Uniform.jpg'
import CheckoutForm from "../components/CheckoutForm";
import BookingHeader from '../assets/BookingHeader.jpg'
import Watermark from '../assets/Watermark.png'
import Input from "../components/Input";
import Dropdown from "../components/Dropdown";
import CalendarNew from "../components/CalendarNew";
import { useNavigate } from "react-router-dom";

const stripePromise = loadStripe(stripeKey);

const Bookings = () => {

    const bookingClassLimit = 20

    const [clientSecret, setClientSecret] = useState("");
    const [sum, setSum] = useState("");
    const [loading, setLoading] = useState(true);

    const [currentDate, setCurrentDate] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }))
    const [actualDate, setActualDate] = useState(startOfWeek(new Date(), { weekStartsOn: 1 }))
    const [schedules, setSchedules] = useState([])
    const [bookingsForWeek, setBookingsForWeek] = useState([])
    const [showBookPopup, setShowBookPopup] = useState(false)
    const [showExpressInterest, setShowExpressInterest] = useState(false)
    const [showExpressInterestMessage, setShowExpressInterestMessage] = useState(false)
    const [currentBooking, setCurrentBooking] = useState(false)

    const [activity, setActivity] = useState('')
    const [parentName, setParentName] = useState('')
    const [childName, setChildName] = useState('')
    const [email, setEmail] = useState('')
    const [phoneNumber, setPhoneNumber] = useState('')
    const [postcode, setPostCode] = useState('')

    const existingCartBookings = useSelector(state => state.user.bookings)

    const [showSizing, setShowSizing] = useState(false)
    // const [addedUniform, setAddedUniform] = useState(false)

    const [shirtSize, setShirtSize] = useState('')
    const [shortSize, setShortSize] = useState('')
    const uniformPrice = 40

    const [showCart, setShowCart] = useState(false)

    const weekOfYear = getWeek(currentDate)

    const dispatch = useDispatch()
    const navigate = useNavigate()


    const topSizes = [['Half Chest', '33', '36', '39', '42'], ['Body Length', '43', '46', '49', '54'], ['Sleeve Length', '16.5', '18', '19.5', '21']]

    const shortSizes = [['Length', '28', '28', '28', '28'], ['Waist', '22', '24', '26', '28']]

    useEffect(() => {
        getSchedule()
    }, [])

    useEffect(() => {
        if (currentBooking) {
            dispatch(setBookings([...existingCartBookings, currentBooking]))
            setCurrentBooking()
            toast.success('Class added to cart', { position: 'top-center', style: { marginTop: '20px' } })
            setShowBookPopup(false)
        }
    }, [currentBooking])

    useEffect(() => {
        getBookings()
    }, [currentDate])

    useEffect(() => {
        if (existingCartBookings.length > 0 && shirtSize) {
            const hasNoFullClass = !existingCartBookings.find(r => !r.isSingleClass && !r.isTrial)

            if (hasNoFullClass) {
                setShirtSize('')
                setShortSize('')
            }
        }
    }, [existingCartBookings])

    const getSchedule = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'booking-schedule'))))
        // console.log('schedule', docs)
        setSchedules(docs)
    }

    const getBookings = async () => {
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'bookings'), where('fromWeek', '<=', weekOfYear), where('tillWeek', '>=', weekOfYear), where('year', '==', new Date().getFullYear()))))
        // console.log('bookings', docs)
        setBookingsForWeek(docs)
        setLoading(false)
    }

    const headers = ['Time', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']




    const checkIfBookingsReachedLimit = (desc, day) => {
        const matchingBookingsLength = bookingsForWeek.filter(r => r.desc === desc && r.day == day).length
        if (matchingBookingsLength >= bookingClassLimit) {
            return true
        }
        return false
    }

    const returnWeekSchedule = (desc) => {

        const hasMatchingSchedule = schedules.find(schedule => parseInt(schedule.startWeekIndex) <= weekOfYear && parseInt(schedule.endWeekIndex) >= weekOfYear)

        if (hasMatchingSchedule) {
            return [
                { expressInterest: true, expressDay: 'Mon' },
                { expressInterest: true, expressDay: 'Tue' },
                {
                    name: 'Yoga',
                    day: 'Wed',
                    backgroundColor: '#fff601',
                    disabled: checkIfBookingsReachedLimit(desc, 'Wed')
                },
                {
                    name: 'Gymnastics',
                    day: 'Thu',
                    backgroundColor: '#18d904',
                    disabled: checkIfBookingsReachedLimit(desc, 'Thu')
                },
                {
                    name: 'Music',
                    day: 'Fri',
                    backgroundColor: '#ff82e0',
                    disabled: checkIfBookingsReachedLimit(desc, 'Fri')
                },
                {
                    name: 'Sport',
                    day: 'Sat',
                    backgroundColor: '#15bafe',
                    disabled: checkIfBookingsReachedLimit(desc, 'Sat')
                },
                { expressInterest: true, expressDay: 'Sun' },
            ]
        }

        return [null, null, null, null, null, null, null]


    }

    const timeblocks = [
        {
            title: '9:30AM - 10AM',
            desc: '2-3 yo',
            dayIndexes: returnWeekSchedule('2-3 yo'),
            price: 20
        },
        {
            title: '10:15AM - 11AM',
            desc: '3-4 yo',
            dayIndexes: returnWeekSchedule('3-4 yo'),
            price: 25
        },
        {
            title: '11:15AM - 12PM',
            desc: '4-6 yo',
            dayIndexes: returnWeekSchedule('4-6 yo'),
            price: 25
        }
    ]

    const findEnrollCost = (returnPrice) => {

        let message = ''
        const hasMatchingSchedule = schedules.find(schedule => parseInt(schedule.startWeekIndex) <= weekOfYear && parseInt(schedule.endWeekIndex) >= weekOfYear)

        if (hasMatchingSchedule) {
            const pendingWeeks = (parseInt(hasMatchingSchedule.endWeekIndex) - weekOfYear) + 1

            const cost = pendingWeeks * showBookPopup.price
            message = `${pendingWeeks}, Total: $${cost} ($${showBookPopup.price} per class)`
            if (returnPrice) {
                return cost
            }
        }


        return message
    }

    const getLastWeekIndex = () => {
        const hasMatchingSchedule = schedules.find(schedule => parseInt(schedule.startWeekIndex) <= weekOfYear && parseInt(schedule.endWeekIndex) >= weekOfYear)

        if (hasMatchingSchedule) {
            return parseInt(hasMatchingSchedule.endWeekIndex)
        }

        return 0
    }

    const findDayOfWeek = (day) => {
        const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        return days.findIndex(r => r === day)
    }


    const handleExpressInterest = async () => {

        setLoading(true)
        const payload = {
            day: showExpressInterest.expressDay,
            time: showExpressInterest.title,
            age: showExpressInterest.desc,
            activity: activity.value,
            parentName,
            email,
            phoneNumber,
            postcode,
            currentDate: format(currentDate, 'dd/MMM/yyyy'),
            currentDateISO: currentDate.toISOString(),
            created: new Date().toISOString()
        }

        await addDoc(collection(db, 'express-interest-booking'), payload)

        toast.success('Your interest has been sent.')
        setShowExpressInterestMessage(true)

        setTimeout(() => {
            setLoading(false)
            setShowExpressInterest(false)
            setShowExpressInterestMessage(false)
        }, 2000)
    }

    const handleCreatePaymentIntent = async () => {

        // Check if email used in past free trial bookings.

        setLoading(true)
        const docs = await getFirebaseDocs(await getDocs(query(collection(db, 'bookings'), where('isTrial', '==', true), where('email', '==', email))))

        if (docs.length > 0 && existingCartBookings.find(r => r.isTrial)) {
            toast.error('You have already used your free trial. Please remove it from cart.')
            setLoading(false)
            return
        }

        const sumLoc = existingCartBookings.map(r => r.totalPrice).reduce((partialSum, a) => partialSum + a, 0) + (shirtSize ? uniformPrice : 0)
        const doc = await addDoc(collection(db, 'bookings-temp'), {
            items: existingCartBookings,
            parentName,
            email,
            phoneNumber,
            postcode,
            shirtSize: shirtSize ? shirtSize.value : '',
            shortSize: shortSize ? shortSize.value : '',
            sum: sumLoc
        })

        console.log(doc.id)

        const resp = await axios.post('https://australia-southeast2-mini-monstars-au.cloudfunctions.net/createPaymentIntent', { id: doc.id },)
        // const resp = await axios.post('http://127.0.0.1:5001/mini-monstars-au/australia-southeast2/createPaymentIntent', { id: doc.id },)

        console.log(resp.data)
        if (resp.data.err) {
            toast.error('Unknown error ocurred. Try again.')
            setLoading(false)
            return
        }
        if (resp.data.data.bookingCompletedId) {
            const bookingCompletedId = resp.data.data.bookingCompletedId
            navigate(`/orderComplete?tempBookingId=${bookingCompletedId}`)
        } else {
            setClientSecret(resp.data.data.clientSecret)
            setSum(sumLoc)
        }

        setLoading(false)
    }


    if (clientSecret) {
        const appearance = {
            theme: 'stripe',
        };
        // Enable the skeleton loader UI for optimal loading.
        const loader = 'auto';

        return (<div style={{ width: '100%', height: '100vh', overflow: 'scroll', backgroundColor: '#fed82b', }}>
            <img src={BookingHeader} style={{ width: '100%' }} />

            <Elements options={{ clientSecret, appearance, loader, }} stripe={stripePromise}>
                <CheckoutForm amount={sum} setClientSecret={setClientSecret} />
            </Elements>
        </div>)
    }

    return <div style={{ backgroundColor: '#fed82b', height: '100vh', overflow: 'scroll', position: 'relative' }}>

        <img src={BookingHeader} style={{ width: '100%' }} />
        {loading && <p style={{ margin: 'auto', textAlign: 'center' }}>Loading... Please wait.</p>}
        <img src={Watermark} className='watermark' style={{ zIndex: 0, display: 'flex', position: 'absolute', maxHeight: '600px', width: '100%', height: '100%', objectFit: 'contain', opacity: 0.2 }} />

        {showCart ? <div style={{ padding: '10px', maxWidth: '450px', width: 'calc(100% - 20px)', position: 'relative', margin: 'auto', zIndex: 10, display: 'flex', flexDirection: 'column' }}>
            <h2>Your Details</h2>
            <Input bold type={'text'} errorMessage={''} errors={[]} name={'parentName'} value={parentName} setValue={setParentName} label={'Parent Name'} />
            <div style={{ marginBottom: '-15px' }} />
            <Input bold type={'email'} errorMessage={''} errors={[]} name={'email'} value={email} setValue={setEmail} label={'Email'} />
            <div style={{ marginBottom: '-15px' }} />
            <Input bold type={'numeric'} errorMessage={''} errors={[]} name={'phoneNumber'} value={phoneNumber} setValue={v => (!v || (v && v.match(/\d/))) && setPhoneNumber(v)} label={'Phone Number'} />
            <div style={{ marginBottom: '-15px' }} />
            <Input bold type={'numeric'} errorMessage={''} errors={[]} name={'postcode'} value={postcode} setValue={setPostCode} label={'Post Code'} />

            {!shirtSize && existingCartBookings.length > 0 && existingCartBookings.find(r => !r.isSingleClass && !r.isTrial) && <div style={{ padding: '5px', borderRadius: 5, border: '1px solid red', background: '#f2d75c' }}>
                <p>⚠️ All our classes require a uniform to be worn. You do not require uniform for trial classes. <span className="hover" style={{ textDecorationLine: 'underline', color: '#1e90ff' }} onClick={() => setShowSizing(true)}>Pick Size</span>
                </p>
                <img src={UniformImg} style={{ width: '150px', height: '150px', marginTop: '20px', borderRadius: '12px' }} />
            </div>}

            <ModalComp showModal={!!showSizing} setShowModal={setShowSizing}>
                <h3 style={{ margin: 0 }}>Uniform Sizes</h3>

                <h4 style={{ margin: 0 }}>TOP</h4>
                <table>
                    <thead>
                        <th>
                            Size(cm)
                        </th>
                        <th>
                            4
                        </th>
                        <th>
                            6
                        </th>
                        <th>
                            8
                        </th>
                        <th>
                            10
                        </th>
                    </thead>
                    <tbody>
                        {topSizes.map(row => <tr key={row[0]}>
                            {row.map(data => <td key={`${row[0]}-${data}`}>{data}</td>)}
                        </tr>)}
                    </tbody>
                </table>

                <h4 style={{ margin: 0, marginTop: '10px' }}>SHORTS</h4>
                <table>
                    <thead>
                        <th>
                            Size (cm)
                        </th>
                        <th>
                            4
                        </th>
                        <th>
                            6
                        </th>
                        <th>
                            8
                        </th>
                        <th>
                            10
                        </th>
                    </thead>
                    <tbody>
                        {shortSizes.map(row => <tr key={row[0]}>
                            {row.map(data => <td key={`${row[0]}-${data}`}>{data}</td>)}
                        </tr>)}
                    </tbody>
                </table>
                <Dropdown label={'Choose Top Size'} options={['4', '6', '8', '10'].map(r => ({ label: r, value: r }))} errorFields={[]} value={shirtSize} setValue={setShirtSize} />
                <Dropdown label={'Choose Shorts Size'} options={['4', '6', '8', '10'].map(r => ({ label: r, value: r }))} errorFields={[]} value={shortSize} setValue={setShortSize} />

                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button disabled={loading} className="secondary" style={{ marginLeft: 0, marginRight: '20px' }} onClick={() => setShowSizing(false)}>Back</button>
                    <button disabled={!shirtSize || !shortSize || loading} onClick={() => { setShowSizing(false) }}>Save</button>
                </div>

            </ModalComp>

            <h2>Cart</h2>

            <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px' }}>
                <div style={{ fontWeight: 'bold', width: 'calc(100% - 100px)' }}>
                    Name
                </div>
                <div style={{ fontWeight: 'bold', width: '100px' }}>
                    Price
                </div>
                <div style={{ fontWeight: 'bold' }}>
                    Total
                </div>
            </div>


            {
                existingCartBookings.map((booking, index) => <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', paddingBottom: '10px', borderBottom: '2px solid grey' }}>
                    <div style={{ width: 'calc(100% - 100px)' }}>
                        <p style={{ margin: 0 }}>{booking.day} {booking.name} {booking.title}</p>
                        <p style={{ margin: 0 }}>{booking.isSingleClass ? `Single Class (${format(new Date(booking.startDate), 'dd MMM yyyy')})` : booking.isTrial ? `Free Trial (${format(new Date(booking.startDate), 'dd MMM yyyy')})` : `${(getLastWeekIndex() - weekOfYear + 1)} weeks remaining`}</p>
                        <p style={{ margin: 0 }}>{booking.desc}</p>
                        <p style={{ fontWeight: 'bold', color: 'red' }} className="hover" onClick={() => { dispatch(setBookings(existingCartBookings.filter((r, idx) => idx !== index))) }}>Remove</p>
                    </div>

                    <p style={{ fontWeight: 'bold', width: '100px' }}>${booking.isTrial ? 0 : booking.isSingleClass ? booking.price + 5 : booking.price}</p>

                    <p style={{ fontWeight: 'bold' }}>${booking.totalPrice}</p>
                </div>)
            }

            {
                shirtSize && <div style={{ display: 'flex', alignItems: 'center', marginTop: '20px', paddingBottom: '10px', borderBottom: '2px solid grey' }}>
                    <div style={{ width: 'calc(100% - 100px)' }}>
                        <p style={{ margin: 0 }}>Uniform</p>
                        <p style={{ margin: 0 }}>Shirt Size:{shirtSize.value}</p>
                        <p style={{ margin: 0 }}>Short Size:{shortSize.value}</p>
                        <p style={{ fontWeight: 'bold', color: 'red' }} className="hover" onClick={() => { setShowSizing(true) }}>Update</p>

                    </div>
                    <p style={{ fontWeight: 'bold', width: '100px' }}>${uniformPrice}</p>
                    <p style={{ fontWeight: 'bold' }}>${uniformPrice}</p>
                </div>
            }


            {existingCartBookings.length === 0 && <p style={{ textAlign: 'center' }}>No items in your cart.</p>}
            <hr style={{ marginTop: '10px' }} />

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <div style={{ width: 'calc(100% - 100px)' }}>
                    <p style={{ margin: 0, fontWeight: 'bold' }}>Total</p>
                </div>
                <p style={{ width: '100px', margin: 0 }}>-</p>
                <p style={{ margin: 0, fontWeight: 'bold' }}>${existingCartBookings.map(r => r.totalPrice).reduce((partialSum, a) => partialSum + a, 0) + (shirtSize ? uniformPrice : 0)}</p>

            </div>

            {loading && <p style={{ margin: 'auto', textAlign: 'center' }}>Loading... Please wait.</p>}

            <div style={{ display: 'flex', alignItems: 'center' }}>
                <button disabled={loading} className="secondary" style={{ marginLeft: 0, marginRight: '20px' }} onClick={() => setShowCart(false)}>Back</button>
                <button disabled={!parentName || !email || !phoneNumber || !postcode || checkEmailInValid(email) || existingCartBookings.length === 0 || loading} onClick={handleCreatePaymentIntent}>Continue</button>
            </div>


        </div> : <div style={{ zIndex: 10, position: 'relative', display: 'flex', flexDirection: 'column' }}>
            <div style={{ width: '60px', marginLeft: 'auto', display: 'flex', marginRight: '20px' }} className="hover" onClick={() => existingCartBookings.length > 0 && setShowCart(true)}>
                <div style={{ color: 'blue' }}>Cart</div>
                <img src={Cart} style={{ width: '30px', }} />
                <div style={{ color: 'blue' }}>{existingCartBookings.length}</div>
            </div>


            <ModalComp showModal={!!showExpressInterest} setShowModal={setShowExpressInterest}>
                <h2 style={{ margin: 0 }}>Express Interest</h2>
                <h3 style={{ margin: 0, marginTop: '5px' }}> {showExpressInterest.expressDay}, {showExpressInterest.title}  {showExpressInterest.desc}</h3>
                <Dropdown label={'Activity'} options={['Yoga', 'Gymnastics', 'Music', 'Sport', 'Sensory Fusion'].map(r => ({ label: r, value: r }))} errorFields={[]} value={activity} setValue={setActivity} />
                <Input bold type={'text'} errorMessage={''} errors={[]} name={'parentName'} value={parentName} setValue={setParentName} label={'Parent Name'} />
                <div style={{ marginBottom: '-15px' }} />
                <Input bold type={'email'} errorMessage={''} errors={[]} name={'email'} value={email} setValue={setEmail} label={'Email'} />
                <div style={{ marginBottom: '-15px' }} />
                <Input bold type={'numeric'} errorMessage={''} errors={[]} name={'phoneNumber'} value={phoneNumber} setValue={v => (!v || (v && v.match(/\d/))) && setPhoneNumber(v)} label={'Phone Number'} />
                <div style={{ marginBottom: '-15px' }} />
                <Input bold type={'numeric'} errorMessage={''} errors={[]} name={'postcode'} value={postcode} setValue={setPostCode} label={'Post Code'} />

                {showExpressInterestMessage && <p style={{ color: 'green' }}> Your interest has been sent!</p>}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <button disabled={loading} className="secondary" style={{ marginLeft: 0, marginRight: '20px' }} onClick={() => setShowExpressInterest(false)}>Back</button>
                    <button disabled={!activity || !parentName || !email || !phoneNumber || !postcode || checkEmailInValid(email) || loading} onClick={handleExpressInterest}>Send</button>
                </div>
            </ModalComp>

            <ModalComp showModal={!!showBookPopup} setShowModal={setShowBookPopup}>
                <h2 style={{ margin: 0 }}>Book {showBookPopup.name}</h2>
                <h3 style={{ margin: 0, marginTop: '5px', color: 'rgb(21, 186, 254)' }}> {showBookPopup.day}, {showBookPopup.title}  {showBookPopup.desc}</h3>
                <p>Weeks remaining in term: {findEnrollCost()} </p>
                <div style={{ width: '300px' }}>
                    <Input bold type={'text'} errorMessage={''} errors={[]} name={'childName'} value={childName} setValue={setChildName} label={'Child\'s Name'} />
                </div>
                <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>

                    <button style={{ maxWidth: '200px' }} disabled={!childName} onClick={() => { setCurrentBooking({ ...showBookPopup, childName, startDate: addDays(currentDate, findDayOfWeek(showBookPopup.day)).toISOString(), startDateString: format(addDays(currentDate, findDayOfWeek(showBookPopup.day)), 'dd MMM yyyy'), endDateString: format(addDays(currentDate, findDayOfWeek(showBookPopup.day)), 'dd MMM yyyy'), isTrial: true, totalPrice: 0, fromWeek: weekOfYear, tillWeek: weekOfYear, year: new Date().getFullYear() }) }}> Book Free Trial</button>
                    <button style={{ maxWidth: '200px' }} disabled={!childName} onClick={() => { setCurrentBooking({ ...showBookPopup, childName, startDate: addDays(currentDate, findDayOfWeek(showBookPopup.day)).toISOString(), startDateString: format(addDays(currentDate, findDayOfWeek(showBookPopup.day)), 'dd MMM yyyy'), endDateString: format(addDays(currentDate, findDayOfWeek(showBookPopup.day)), 'dd MMM yyyy'), isSingleClass: true, fromWeek: weekOfYear, totalPrice: showBookPopup.price + 5, tillWeek: weekOfYear, year: new Date().getFullYear() }) }}> Book Class ${showBookPopup.price + 5}</button>

                    <button style={{ maxWidth: '200px' }} disabled={!childName} onClick={() => { setCurrentBooking({ ...showBookPopup, childName, startDate: addDays(currentDate, findDayOfWeek(showBookPopup.day)).toISOString(), startDateString: format(addDays(currentDate, findDayOfWeek(showBookPopup.day)), 'dd MMM yyyy'), endDateString: format(addDays(addWeeks(currentDate, getLastWeekIndex() - weekOfYear), findDayOfWeek(showBookPopup.day)), 'dd MMM yyyy'), isEnroll: true, fromWeek: weekOfYear, totalPrice: findEnrollCost(true), tillWeek: getLastWeekIndex(), year: new Date().getFullYear() }) }}> Enrol Now</button>
                    <button className="textButton" style={{ marginTop: '30px', width: '120px' }} onClick={() => setShowBookPopup(false)}> Cancel</button>
                </div>
            </ModalComp>
            <div className="container-booking-calendar" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%', overflow: 'scroll', }}>
                {/* <div style={{ display: 'flex', alignItems: 'center', gap: '10px', margin: 'auto' }}>
                    <b className="hover" style={{ color: '#FF7100', fontSize: '21px' }} onClick={() => setCurrentDate(subDays(currentDate, 7))}>{'<'}</b>
                    <p>Week: {format(currentDate, 'dd MMM yyyy')} - {format(addDays(currentDate, 6), 'dd MMM yyyy')} </p>
                    <b className="hover" style={{ color: '#FF7100', fontSize: '21px' }} onClick={() => setCurrentDate(addDays(currentDate, 7))}>{'>'}</b>
                </div> */}

                <CalendarNew date={currentDate} setDate={setCurrentDate} actualDate={actualDate} setActualDate={setActualDate} />

                <table style={{ maxWidth: '1216px', margin: 'auto' }}>
                    <thead>
                        <tr>
                            {headers.map((header, index) => <th key={header} className={index === 0 || (index - 1) === differenceInDays(actualDate, currentDate) ? '' : "hide"} style={{ textAlign: 'center', backgroundColor: 'red', color: 'rgb(21, 186, 254)', }}>
                                {header.toUpperCase()}
                                <br />
                                {index !== 0 && format(addDays(currentDate, index - 1), 'dd MMM')}
                            </th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {timeblocks.map(row => <tr key={row.title}>
                            <td style={{ backgroundColor: 'red', textAlign: 'center', }}>
                                <b style={{ margin: 0, color: 'rgb(21, 186, 254)', textAlign: 'center', }}>{row.title}</b>
                                <p style={{ margin: 0, color: '#FFFF00', }}>{row.desc}</p>
                            </td>
                            {row.dayIndexes.map((day, index) => <td key={row.title + index} className={index === differenceInDays(actualDate, currentDate) ? '' : "hide"} style={{ textAlign: 'center', fontFamily: 'Marker-Felt', textTransform: 'uppercase', backgroundColor: (day && !day.expressInterest) ? day.backgroundColor : 'white', opacity: day && day.disabled ? 0.5 : 1 }} onClick={() => { day && (day.expressInterest ? setShowExpressInterest({ title: row.title, desc: row.desc, expressDay: day.expressDay }) : !day.disabled && setShowBookPopup({ day: day.day, name: day.name, weekOfYear, title: row.title, desc: row.desc, price: row.price })) }}>
                                {day ? (day.disabled ? 'Booked out!' : (day.expressInterest ? 'Express Interest' : day.name)) : ''}
                            </td>)}
                        </tr>)}
                    </tbody>
                </table>
                {existingCartBookings.length > 0 && <div className="hover" style={{ color: 'blue', margin: '10px auto', display: 'flex', alignItems: 'center' }} onClick={() => setShowCart(true)}>View Cart
                    <img src={Cart} style={{ width: '30px', }} />
                    (<div style={{ color: 'blue' }}>{existingCartBookings.length}</div>)</div>}
            </div>
        </div>
        }

    </div >
}

export default Bookings
